import React from 'react'

import { Alert } from '@frame/ui-primitives/alert'

import { Transition } from '@headlessui/react'

type FormErrorsProps = {
  visible: boolean
  children: JSX.Element[]
}

export function FormErrors({ visible, children }: FormErrorsProps) {
  if (!visible) {
    return null
  }

  return (
    <Transition
      show
      appear
      as="div"
      enter="ease-out duration-300"
      enterFrom="opacity-0 translate-y-[30px]"
      enterTo="opacity-100 translate-y-[8px]"
      leave="ease-in duration-300"
      leaveFrom="opacity-100 -translate-y-[8px]"
      leaveTo="opacity-0 translate-y-[30px]"
    >
      <Alert variant="error" className="-mt-2 mb-3">
        Please correct the following errors:
        <ul className="ml-2 mt-1 list-inside list-disc">{children}</ul>
      </Alert>
    </Transition>
  )
}
